import { gql, useQuery } from '@apollo/client'

import { apolloCache } from '@cred/shared/apollo'

import { PSL } from 'common/const/marketplace'

export default function useFetchLenderStrapiData({ vertical, partner, lenders }) {
  const skip = () => {
    if (partner !== 'wsj') return true
    if (!vertical) return true
    return false
  }
  const verticalStrapi = vertical === PSL ? 'privateStudentLoans' : null
  const { data } = useQuery(
    gql`
      query strapiGetLendersForVertical($vertical: strapiVerticalEnum!) {
        strapiGetLendersForVertical(vertical: $vertical) {
          slug
          buySideContent {
            rating
          }
        }
      }
    `,
    {
      client: apolloCache.getClient(),
      skip: skip(),
      variables: { vertical: verticalStrapi },
      onError: (error) => {
        console.error('==> Error fetching strapi lenders', error)
      },
    },
  )

  if (!data?.strapiGetLendersForVertical) return []

  const slugs = lenders.map((l) => l.slug)
  const strapiRequstedLenders = data.strapiGetLendersForVertical.filter((l) =>
    slugs.includes(l.slug),
  )
  return strapiRequstedLenders
}
